import ApiService from "@Src/services/ApiService";
import { INSTITUTE_API_ROUTES } from "./Institute.api.constant";

export async function checkInstituteExamLimit() {
    return ApiService.fetchData({
        url: INSTITUTE_API_ROUTES.CHECK_INSTITUTE_EXAM_LIMIT,
        method: "get"
    });
}
